// AUTO-GENERATED by scripts/generate-i18n-versions.js — do not edit.
export const I18N_VERSIONS: Record<string, string> = {
  "ar-SA": "20a88dcd",
  "ar": "5092650a",
  "en-SA": "eb4e2265",
  "en": "c9df6a28",
};
